import {
  getNotificationList,
  getNotificationCount,
  getFreeformTypeList,
  getAttachmentTypeList,
  getNotificationDetails,
  getNAMNotificationDetails,
  saveNotificationDetails,
  sendNewNotification,
  getNotificationSubmissionStatus,
  fileUploadNotification,
  markNotificationCompleted
} from "@/common/service/apiaggregator/notificationAgreegatorService";
import { convertToLowerCase, formatAndSortData } from "@/common/utils/generic/commonHelper.js";
import { constants } from "@/lib/CONSTANTS.js";

const getFetchType = () => {
  switch (state.folderType) {
    case "INBOX": {
      if (convertToLowerCase(state.filterType) === "all") {
        return "ACTIVE_ALL";
      } else if (convertToLowerCase(state.filterType) === "action") {
        return "ACTIVE_ACTION";
      } else if (convertToLowerCase(state.filterType) === "information") {
        return "ACTIVE_INFORMATION";
      }
      break;
    }
    case "COMPLETED": {
      if (convertToLowerCase(state.filterType) === "all") {
        return "COMPLETED_ALL";
      } else if (convertToLowerCase(state.filterType) === "action") {
        return "COMPLETED_ACTION";
      } else if (convertToLowerCase(state.filterType) === "information") {
        return "COMPLETED_INFORMATION";
      }
      break;
    }
    case "SENT": {
      return "SENT";
    }
  }
};

const commonCustomStatus = [
  {
    name: "",
    value: "",
    label: "Select"
  },
  {
    name: "HOLD",
    value: "HOLD",
    label: "Hold"
  },
  {
    name: "HOLD_REMOVED",
    value: "HOLD_REMOVED",
    label: "Hold Removed"
  }
];

const customStatusMap = {
  US: [
    { label: "Select", name: "", value: "" },
    { label: "Released", name: "Release", value: "Release" },
    { label: "Warehouse released", name: "WHR", value: "WHR" },
    { label: "Exported", name: "Export", value: "Export" },
    { label: "Arrived", name: "Arrival", value: "Arrival" },
    { label: "Move authorized", name: "Move", value: "Move" },
    {
      label: "Permit to transfer authorized",
      name: "Port",
      value: "Port"
    },
    { label: "Do not load", name: "Do Not Load", value: "Do Not Load" },
    { name: "HOLD", value: "HOLD", label: "Hold" },
    { name: "HOLD_REMOVED", value: "HOLD_REMOVED", label: "Hold Removed" },
    { label: "Exam", name: "Exam", value: "Exam" },
    { label: "Exam completed", name: "Exam completed", value: "Exam completed" }
  ],
  CA: [
    { label: "Select", name: "", value: "" },
    { label: "Released", name: "Release", value: "Release" },
    { label: "Do not load", name: "Do Not Load", value: "Do Not Load" },
    { name: "HOLD", value: "HOLD", label: "Hold" },
    { name: "HOLD_REMOVED", value: "HOLD_REMOVED", label: "Hold Removed" },
    { label: "Exam", name: "Exam", value: "Exam" },
    { label: "Exam completed", name: "Exam completed", value: "Exam completed" }
  ]
};

const getFilteredNotificationCodes = (manifestType, country) => {
  const isExportManifest = Array.isArray(manifestType)
    ? manifestType.includes("Export Manifest")
    : manifestType === "Export Manifest";
  return isExportManifest ? commonCustomStatus : customStatusMap[country];
};

const state = {
  notificationList: [],
  currentPage: 1,
  sortByDate: "DESC",
  totalNotificationCount: 0,
  notificationCountLoader: false,
  manifestType: "",

  dateRangeFilter: {
    start: null,
    end: null,
    pristine: true,
    touched: null,
    cleared: null
  },
  notificationListLoader: false,
  newMessageBoxStatus: false,
  addTemplateStatus: false,

  notificationCounty: null,
  itemsPerPage: constants.pageSettings.notfication.resultsPerPage,
  fetchType: constants.pageSettings.notfication.defaultFetchType,
  sortBy: constants.pageSettings.notfication.defaultSortBy,

  selectedNotificationDetails: null,
  notificationItemLoader: false,
  sendMessageButtonLoader: false,

  newNotificationCodeList: [],
  oldNotificationCodeList: [],
  attachmentDocumentList: [],

  notificationsubmissionstatus: [],
  notificationsubmissionstatusLoader: false,

  notificationcomplete: [],
  notificationcompleteLoader: false,

  notificationCode: "",
  filterType: "ACTION",
  folderType: "INBOX",
  bolNumberToSearch: "",
  tId: ""
};

const mutations = {
  setNotificationList(state, result) {
    state.notificationList = result;
  },
  addItemsNotificationList(state, result) {
    state.notificationList = [...state.notificationList, ...result];
  },
  setCurrentPage(state, value) {
    state.currentPage = value;
  },
  setManifestType(state, value) {
    state.manifestType = value;
  },
  setNotificationCount(state, result) {
    state.totalNotificationCount = result;
  },
  setNotificationCode(state, result) {
    state.notificationCode = result;
  },
  setSortByDate(state, result) {
    state.sortByDate = result;
  },
  setBOLSearchValue(state, result) {
    state.bolNumberToSearch = result;
  },
  setNewNotificationCodes(state, result) {
    state.newNotificationCodeList = result;
  },
  setOldNotificationCodes(state, result) {
    state.oldNotificationCodeList = result;
  },
  setAttachmentDocumentList(state, result) {
    state.attachmentDocumentList = result;
  },
  setNotificationCountry(state, result) {
    state.notificationCounty = result;
  },
  setNotificationDetails(state, result) {
    state.selectedNotificationDetails = result;
  },
  setNotificationSubmissionStatus(state, result) {
    state.notificationSubmissionStatus = result;
  },
  setNotificationComplete(state, result) {
    state.notificationComplete = result;
  },
  setFetchType(state, result) {
    state.fetchType = result;
  },
  setFilterType(state, result) {
    state.filterType = result;
  },
  setSortType(state, result) {
    state.sortBy = result;
  },
  setFolderType(state, result) {
    state.folderType = result;
  },
  setTid(state, result) {
    state.tId = result;
  },
  setNewMessageBoxStatus(state, result) {
    state.newMessageBoxStatus = result;
  },
  setAddTemplateStatus(state, result) {
    state.addTemplateStatus = result;
  },
  setErrorState(state, param) {
    state[`${param.type}Error`] = param.error
      ? "hasError" in param.error
        ? param.error
        : { hasError: true, status: param.error.status, message: param.error.message }
      : null;
  },
  setLoadingState(state, param) {
    state[`${param.type}Loader`] = param.value;
  },
  setDateRangeFilter(state, selection) {
    const { startDate, endDate } = selection;
    state.dateRangeFilter.start = startDate;
    state.dateRangeFilter.end = endDate;
    state.dateRangeFilter.pristine = false;
    state.dateRangeFilter.touched = true;
    state.dateRangeFilter.cleared = startDate && endDate ? false : true;
  },
  setManualStatus(state, result) {
    state.manualSub = result;
  }
};
const actions = {
  async fetchNotificationList({ commit }, type) {
    if (type !== "add") {
      commit("setNotificationList", []);
      commit("setLoadingState", { type: "notificationList", value: true });
    }
    try {
      let rawData,
        data = [];
      const queryParams = {
        fromDate: state.dateRangeFilter?.start,
        toDate: state.dateRangeFilter?.end,
        page: state.currentPage - 1,
        size: state.itemsPerPage,
        countryCode: state.notificationCounty,
        sortBy: state.sortBy,
        notificationCodes: state.notificationCode ? state.notificationCode : "",
        sortByDirection: state.sortByDate,
        search: state.bolNumberToSearch,
        fetchType: state.fetchType,
        manifestType: state.manifestType ? state.manifestType : ""
      };
      rawData = await getNotificationList(queryParams, true);
      if (rawData.status > 200 && rawData.status <= 299) {
        data = [];
        commit("setErrorState", {
          type: "notificationList",
          error: { hasError: false, status: rawData.status, message: rawData.statusText }
        });
      } else {
        data = await rawData.json();
      }

      // To convert SN from utc to et and sort by date and time
      data = formatAndSortData(data, queryParams);

      if (data && data[0] && data[0].countryCode && data[0].countryCode.length) {
        commit("setNotificationCountry", data[0].countryCode);
      }
      if (type === "add") {
        commit("addItemsNotificationList", data);
      } else {
        commit("setNotificationList", data);
      }
      commit("setErrorState", { type: "notificationList", error: "" });
      commit("setLoadingState", { type: "notificationList", value: false });
    } catch (error) {
      commit("setNotificationList", []);
      commit("setErrorState", { type: "notificationList", error });
      commit("setLoadingState", { type: "notificationList", value: false });
    }
  },

  async fetchNotificationCodes({ commit }, type) {
    if (type) {
      commit("setNewNotificationCodes", []);
    } else {
      commit("setOldNotificationCodes", []);
    }
    commit("setLoadingState", { type: "notificationCode", value: true });
    try {
      let rawData,
        data = [];
      const queryParams = {
        countryCode: state.notificationCounty,
        isNew: type
      };
      rawData = await getFreeformTypeList(queryParams, true);
      if (rawData.status > 200 && rawData.status <= 299) {
        data = [];
        commit("setErrorState", {
          type: "notificationCode",
          error: { hasError: false, status: rawData.status, message: rawData.statusText }
        });
      } else {
        data = await rawData.json();
      }
      if (type) {
        const codesList = [];
        for (const item of data) {
          let tempItem = {
            name: item.code,
            value: item.name,
            label: item.code
          };
          codesList.push(tempItem);
        }
        commit("setNewNotificationCodes", codesList);
      } else {
        const codesList = [];
        for (const item of data) {
          let tempItem = {
            name: item.code,
            value: item.name,
            label: item.code + " (" + item.name + ")"
          };
          codesList.push(tempItem);
        }
        codesList.unshift({
          name: "",
          value: "",
          label: "Select"
        });
        commit("setOldNotificationCodes", codesList);
      }
      commit("setErrorState", { type: "notificationCode", error: "" });
      commit("setLoadingState", { type: "notificationCode", value: false });
    } catch (error) {
      if (type) {
        commit("setNewNotificationCodes", []);
      } else {
        commit("setOldNotificationCodes", []);
      }
      commit("setErrorState", { type: "notificationCode", error });
      commit("setLoadingState", { type: "notificationCode", value: false });
    }
  },

  async fetchAttachmentDocumentList({ commit }, code) {
    commit("setAttachmentDocumentList", []);
    commit("setLoadingState", { type: "attachmentDocumentList", value: true });
    try {
      let rawData,
        data = [];
      const queryParams = {
        countryCode: state.notificationCounty,
        notificationCode: code,
        fetchAttachmentTypes: true // new params to get the attachment types list.
      };
      rawData = await getAttachmentTypeList(queryParams, true);
      if (rawData.status > 200 && rawData.status <= 299) {
        data = [];
        commit("setErrorState", {
          type: "attachmentDocumentList",
          error: { hasError: false, status: rawData.status, message: rawData.statusText }
        });
      } else {
        data = await rawData.json();
      }
      const codesList = [];
      for (const item of data.attachmentTypes) {
        let tempItem = {
          name: item.attachmentTypeCode,
          value: item.attachmentTypeName,
          label: item.attachmentTypeName
        };
        codesList.push(tempItem);
      }
      commit("setAttachmentDocumentList", codesList);
      commit("setErrorState", { type: "attachmentDocumentList", error: "" });
      commit("setLoadingState", { type: "attachmentDocumentList", value: false });
    } catch (error) {
      commit("setAttachmentDocumentList", []);
      commit("setErrorState", { type: "attachmentDocumentList", error });
      commit("setLoadingState", { type: "attachmentDocumentList", value: false });
    }
  },

  async fetchNotificationCount({ commit }) {
    commit("setNotificationCount", 0);
    commit("setLoadingState", { type: "notificationCount", value: true });
    try {
      let rawData,
        data = [];
      const queryParams = {
        fromDate: state.dateRangeFilter?.start,
        toDate: state.dateRangeFilter?.end,
        notificationCodes: state.notificationCode ? state.notificationCode : "",
        countryCode: state.notificationCounty,
        fetchType: state.fetchType,
        search: state.bolNumberToSearch,
        manifestType: state.manifestType
      };
      rawData = await getNotificationCount(queryParams, true);
      if (rawData.status > 200 && rawData.status <= 299) {
        data = [];
        commit("setErrorState", {
          type: "notificationCount",
          error: { hasError: false, status: rawData.status, message: rawData.statusText }
        });
      } else {
        data = await rawData.json();
      }
      commit("setNotificationCount", data);
      commit("setErrorState", { type: "notificationCount", error: "" });
      commit("setLoadingState", { type: "notificationCount", value: false });
    } catch (error) {
      commit("setNotificationCount", 0);
      commit("setErrorState", { type: "notificationCount", error });
      commit("setLoadingState", { type: "notificationCount", value: false });
    }
  },

  async fetchNotificationItem({ commit }, notificationId) {
    commit("setNotificationDetails", null);
    commit("setNewMessageBoxStatus", false);
    commit("setAddTemplateStatus", false);
    commit("setLoadingState", { type: "notificationItem", value: true });
    try {
      let rawData,
        data = [];
      rawData = await getNotificationDetails(notificationId, true);
      if (rawData.status > 200 && rawData.status <= 299) {
        data = [];
        commit("setErrorState", {
          type: "notificationItem",
          error: { hasError: false, status: rawData.status, message: rawData.statusText }
        });
      } else {
        data = await rawData.json();
      }
      data.bolList = [];
      if (data.bolNumber && data.bolNumber.length > 1) {
        for (const item of data.bolNumber) {
          let tempItem = {
            value: item,
            label: item
          };
          data.bolList.push(tempItem);
        }
      }
      commit("setNotificationDetails", data);
      commit("setErrorState", { type: "notificationItem", error: "" });
      commit("setLoadingState", { type: "notificationItem", value: false });
    } catch (error) {
      commit("setNotificationDetails", null);
      commit("setErrorState", { type: "notificationItem", error });
      commit("setLoadingState", { type: "notificationItem", value: false });
    }
  },
  async fetchNAMNotificationItem({ commit }, notificationId) {
    commit("setNotificationDetails", null);
    commit("setNewMessageBoxStatus", false);
    commit("setAddTemplateStatus", false);
    commit("setLoadingState", { type: "notificationItem", value: true });
    try {
      let rawData,
        data = [];
      rawData = await getNAMNotificationDetails(notificationId, true);
      if (rawData.status > 200 && rawData.status <= 299) {
        data = [];
        commit("setErrorState", {
          type: "notificationItem",
          error: { hasError: false, status: rawData.status, message: rawData.statusText }
        });
      } else {
        data = await rawData.json();
      }
      data.bolList = [];
      if (data.bolNumber && data.bolNumber.length > 1) {
        for (const item of data.bolNumber) {
          let tempItem = {
            value: item,
            label: item
          };
          data.bolList.push(tempItem);
        }
      }
      commit("setNotificationDetails", data);
      commit("setErrorState", { type: "notificationItem", error: "" });
      commit("setLoadingState", { type: "notificationItem", value: false });
    } catch (error) {
      commit("setNotificationDetails", null);
      commit("setErrorState", { type: "notificationItem", error });
      commit("setLoadingState", { type: "notificationItem", value: false });
    }
  },
  async fetchNotificationSubmissionStatus({ commit, dispatch }, req_body) {
    commit("setNotificationSubmissionStatus", { type: "notificationSubmissionStatus", value: true });
    try {
      let rawData;
      rawData = await getNotificationSubmissionStatus(req_body, true);
      if (rawData.status > 200 && rawData.status <= 299) {
        commit("setErrorState", {
          type: "notificationSubmissionStatus",
          error: { hasError: false, status: rawData.status, message: rawData.statusText }
        });
      }

      dispatch("fetchBolDetails", req_body.ediTransmissionId);
      commit("setErrorState", { type: "notificationSubmissionStatus", error: "" });
      commit("setNotificationSubmissionStatus", { type: "notificationSubmissionStatus", value: false });
    } catch (error) {
      commit("setErrorState", { type: "notificationSubmissionStatus", error });
      commit("setNotificationSubmissionStatus", { type: "notificationSubmissionStatus", value: false });
    }
  },
  async updateItemAsCompleted({ commit, dispatch }, params) {
    commit("setNotificationComplete", "");
    commit("setLoadingState", { type: "notificationComplete", value: true });
    try {
      let rawData;
      rawData = await markNotificationCompleted(params, true);
      if (rawData.status > 200 && rawData.status <= 299) {
        commit("setErrorState", {
          type: "notificationComplete",
          error: { hasError: false, status: rawData.status, message: rawData.statusText }
        });
      }
      dispatch("updateInboxMessageValue", "INBOX");
      commit("setErrorState", { type: "notificationComplete", error: "" });
      commit("setLoadingState", { type: "notificationComplete", value: false });
    } catch (error) {
      commit("setNotificationComplete", "");
      commit("setErrorState", { type: "notificationComplete", error });
      commit("setLoadingState", { type: "notificationComplete", value: false });
    }
  },
  async saveNotificationDetails({ commit, dispatch }, params) {
    commit("setNotificationComplete", "");
    commit("setLoadingState", { type: "sendMessageButton", value: true });
    try {
      let rawData;
      rawData = await saveNotificationDetails(params, true);
      if (rawData.status > 200 && rawData.status <= 299) {
        commit("setErrorState", {
          type: "notificationComplete",
          error: { hasError: false, status: rawData.status, message: rawData.statusText }
        });
      }
      dispatch("fetchNotificationItem", params.ediTransmissionId);
      // commit("setNotificationComplete", rawData.status);
      commit("setErrorState", { type: "notificationComplete", error: "" });
      commit("setLoadingState", { type: "sendMessageButton", value: false });
    } catch (error) {
      commit("setNotificationComplete", "");
      commit("setErrorState", { type: "notificationComplete", error });
      commit("setLoadingState", { type: "sendMessageButton", value: false });
    }
  },
  async sendNewNotification({ commit, dispatch }, params) {
    commit("setNotificationComplete", "");
    commit("setLoadingState", { type: "sendMessage", value: true });
    try {
      let rawData;
      rawData = await sendNewNotification(params, true);
      if (rawData.status > 200 && rawData.status <= 299) {
        commit("setErrorState", {
          type: "sendMessage",
          error: { hasError: false, status: rawData.status, message: rawData.statusText }
        });
      }
      dispatch("updateInboxMessageValue", "INBOX");
      commit("setErrorState", { type: "sendMessage", error: "" });
      commit("setLoadingState", { type: "sendMessage", value: false });
    } catch (error) {
      commit("setNotificationComplete", "");
      commit("setErrorState", { type: "sendMessage", error });
      commit("setLoadingState", { type: "sendMessage", value: false });
    }
  },
  async fileUploadToNotification({ commit }, file) {
    commit("setNotificationComplete", "");
    commit("setLoadingState", { type: "sendMessage", value: true });
    try {
      let rawData;
      const formData = new FormData();
      formData.append("file", file);

      rawData = await fileUploadNotification(formData, true);
      if (rawData.status > 200 && rawData.status <= 299) {
        commit("setErrorState", {
          type: "sendMessage",
          error: { hasError: false, status: rawData.status, message: rawData.statusText }
        });
      }
      // dispatch("updateInboxMessageValue", "SENT");
      commit("setErrorState", { type: "sendMessage", error: "" });
      commit("setLoadingState", { type: "sendMessage", value: false });
    } catch (error) {
      commit("setNotificationComplete", "");
      commit("setErrorState", { type: "sendMessage", error });
      commit("setLoadingState", { type: "sendMessage", value: false });
    }
  },
  invokeDateRangeSelection({ commit, dispatch }, dateRangeSelection) {
    if (state.currentPage !== 1) {
      commit("setCurrentPage", 1);
    }
    dispatch("resetResults");
    if (state.oldNotificationCodeList < 1) {
      dispatch("fetchNotificationCodes", false);
    }
    if (state.newNotificationCodeList.length < 1) {
      dispatch("fetchNotificationCodes", true);
    }
    commit("setDateRangeFilter", dateRangeSelection);
    dispatch("fetchNotificationList");
    dispatch("fetchNotificationCount");
  },
  //Action to trigger the BOL Search
  invokeBOLSearch({ commit, dispatch }) {
    if (state.currentPage !== 1) {
      commit("setCurrentPage", 1);
    }
    dispatch("resetResults");
    commit("setNotificationCode", "");
    if (state.notificationCounty && (state.notificationCounty == "CA" || state.notificationCounty == "US")) {
      const filteredList = getFilteredNotificationCodes(state.manifestType, state.notificationCounty);
      commit("setOldNotificationCodes", filteredList);
    }
    dispatch("fetchNotificationList", "bolsearch");
    dispatch("fetchNotificationCount");
  },
  invokeLoadMoreNotifications({ commit, dispatch }) {
    commit("setCurrentPage", ++state.currentPage);
    dispatch("fetchNotificationList", "add");
  },
  invokeShowNewMessageBox({ commit, dispatch }) {
    commit("setNotificationDetails", null);
    commit("setNewMessageBoxStatus", true);
    commit("setNotificationCode", "");
    if (state.newNotificationCodeList.length < 1) {
      dispatch("fetchNotificationCodes", true);
    }
    if (state.oldNotificationCodeList < 1) {
      dispatch("fetchNotificationCodes", false);
    }
  },
  invokeShowAddTemplate({ commit, dispatch }) {
    if (!state.selectedNotificationDetails || state.selectedNotificationDetails.messageType === "NR") {
      const statusNotification = state.notificationList.find(
        status => status.name !== "Approved" || status.name === "Rejected"
      );
      dispatch("fetchNAMNotificationItem", statusNotification.ediTransmissionId);
    }
    commit("setAddTemplateStatus", true);
  },
  changeSortType({ commit, dispatch }, value) {
    if (state.currentPage !== 1) {
      commit("setCurrentPage", 1);
    }
    dispatch("resetResults");
    if (value === "DESC") {
      commit("setSortByDate", "ASC");
    }
    dispatch("fetchNotificationCount");
    dispatch("fetchNotificationList");
  },
  //Action to Update/commit BOL Search Key
  updateBOLSearchValue({ commit, dispatch }, value) {
    commit("setBOLSearchValue", value);
    if (!state.notificationCounty || state.notificationCounty.length === 0 || state.notificationCounty === null) {
      if (!state.newNotificationCodeList || state.newNotificationCodeList.length === 0) {
        dispatch("fetchNotificationCodes", false);
        dispatch("fetchNotificationCodes", true);
      }
    }
  },
  invokeCountryChange({ commit, dispatch }, value) {
    if (state.currentPage !== 1) {
      commit("setCurrentPage", 1);
    }
    dispatch("resetResults");
    commit("setNotificationCode", "");
    commit("setNotificationCountry", value);
    if (value && (value === "US" || value === "CA")) {
      const filteredList = getFilteredNotificationCodes(state.manifestType, value);
      commit("setOldNotificationCodes", filteredList);
    } else {
      dispatch("fetchNotificationCodes", true);
      dispatch("fetchNotificationCodes", false);
      if (
        convertToLowerCase(state.folderType) === "sent" &&
        state.newNotificationCodeList &&
        state.newNotificationCodeList.length === 0
      ) {
        commit("setFolderType", "INBOX");
        commit("setFetchType", getFetchType());
      }
      dispatch("fetchNotificationList");
      dispatch("fetchNotificationCount");
    }
  },
  invokeManifestTypeChange({ commit, dispatch }, value) {
    if (state.currentPage !== 1) {
      commit("setCurrentPage", 1);
    }
    dispatch("resetResults");
    commit("setManifestType", value);
    if (state.notificationCounty && (state.notificationCounty === "US" || state.notificationCounty === "CA")) {
      const filteredList = getFilteredNotificationCodes(value, state.notificationCounty);
      commit("setOldNotificationCodes", filteredList);
    }
    dispatch("fetchNotificationList");
    dispatch("fetchNotificationCount");
  },
  invokeNextPageLoad({ commit, dispatch }) {
    if (state.totalNotificationCount / 10 > state.currentPage) {
      commit("setCurrentPage", state.currentPage + 1);
      dispatch("fetchNotificationList", "add");
    }
  },
  invokeNotificationQueryData({ commit }, queryParams) {
    commit("setNotificationCountry", queryParams.country);
    commit("setSortByDate", queryParams.sortBy);
    commit("setNotificationCode", queryParams.subFilter);
    if (queryParams.bol.length > 0) {
      commit("setBOLSearchValue", queryParams.bol);
    }
    let counter = 0;
    if (queryParams.folderType.length > 1) {
      commit("setFolderType", queryParams.folderType);
      counter++;
    }
    if (queryParams.filterType.length > 1) {
      commit("setFilterType", queryParams.filterType);
      counter++;
    }
    if (counter === 2) {
      commit("setFetchType", getFetchType());
    }
  },
  updateAndStoreTid({ commit }, tid) {
    if (tid) {
      commit("setTid", tid);
    }
  },
  updateFilter({ commit, dispatch }, value) {
    commit("setCurrentPage", 1);
    dispatch("resetResults");
    commit("setFilterType", value);
    commit("setFetchType", getFetchType());
    dispatch("fetchNotificationList");
    dispatch("fetchNotificationCount");
  },
  updateNotificationType({ commit, dispatch }, value) {
    commit("setCurrentPage", 1);
    dispatch("resetResults");
    let notificationCode;
    if (value) {
      notificationCode = value;
    } else {
      notificationCode = "";
    }
    commit("setNotificationCode", notificationCode);
    dispatch("fetchNotificationList");
    dispatch("fetchNotificationCount");
  },
  updateInboxMessageValue({ commit, dispatch }, value) {
    commit("setCurrentPage", 1);
    dispatch("resetResults");
    commit("setFolderType", value);
    commit("setFetchType", getFetchType());
    dispatch("fetchNotificationList");
    dispatch("fetchNotificationCount");
  },
  resetResults({ commit }) {
    commit("setNotificationDetails", null);
    commit("setNewMessageBoxStatus", false);
    commit("setAddTemplateStatus", false);
    commit("setNotificationList", []);
    commit("setNotificationCount", 0);
    commit("setSortByDate", "DESC");
    commit("setErrorState", { type: "notificationList", error: null });
    commit("setErrorState", { type: "notificationCount", error: null });
  },
  //Action to Update/commit BOL   Value By the Query Parmeters on Initial
  updateCountryAndBOLSearchValue({ commit, dispatch }, queryParams) {
    commit("setNotificationCountry", queryParams.country);
    commit("setBOLSearchValue", queryParams.bol);
    if (!state.notificationCounty || state.notificationCounty.length === 0 || state.notificationCounty === null) {
      if (!state.newNotificationCodeList || state.newNotificationCodeList.length === 0) {
        dispatch("fetchNotificationCodes", false);
        dispatch("fetchNotificationCodes", true);
      }
    }
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
